import axios from '@/axios'

export default {
  REMOVE_TOKEN (state) {
    localStorage.removeItem('token')
  },
  REMOVE_USER_PROFILE (state) {
    state.profile = null
  },
  SET_TOKEN (state, accessToken) {
  	localStorage.setItem('token', accessToken)
    axios.defaults.headers.common['Authorization'] = `bearer ${accessToken}`
  },
  SET_USER_PROFILE (state, data) {
  	state.profile = data
  },
  SET_REGISTERED_USER (state, data) {
  	state.registeredUser = data
  },
  SET_REGISTERED_DATA(state, data) { // save data before insert to db
    state.registeredData = data
  }
}
